import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '../buttons/button.component';
import { InputComponent } from '../controls/input.component';
import { ActionRowComponent } from '../panels/action-row.component';
import { DialogComponent } from '../panels/dialog.component';
import { RequiredFieldsNoteComponent } from '../labels/required-fields-note.component';

@Component({
  selector: 'app-rename-dialog',
  imports: [
    ActionRowComponent,
    CommonModule,
    DialogComponent,
    ButtonComponent,
    RouterModule,
    InputComponent,
    ReactiveFormsModule,
    RequiredFieldsNoteComponent,
  ],
  template: ` <app-dialog #dialog [label]="label" [width]="width">
    <ng-template #content>
      <form (submit)="renameClick()" [formGroup]="fg">
        <app-required-fields-note />
        <div class="tw-py-8">
          <app-input [control]="fg.controls.renameControl" label="Name" />
        </div>
        <app-action-row>
          <app-button
            icon="fa-check fa-light"
            (click)="renameClick()"
            right1
            [label]="buttonLabel"
            type="submit"
            [loading]="loading"
            [disabled]="
              !fg.valid ||
              (!allowSameValue &&
                fg.controls.renameControl.value === orginalValue)
            "
          />
          <app-button (click)="close()" emphasis="Low" right2 label="Cancel" />
        </app-action-row>
      </form>
    </ng-template>
  </app-dialog>`,
  styles: [],
})
export class RenameDialogComponent {
  @ViewChild('dialog')
  dialog: DialogComponent;

  @Input()
  width = '35rem';

  @Input({ required: true })
  label: string;

  @Input()
  buttonLabel = 'Rename';

  @Input()
  allowSameValue = false;

  @Input()
  extraValidators: ValidatorFn[] = [];

  @Output()
  rename = new EventEmitter<string>();

  fg = new FormGroup({
    renameControl: new FormControl<string>(null, Validators.required),
  });

  protected orginalValue: string;
  loading = false;

  show(value: string) {
    this.dialog.visible = true;
    this.orginalValue = value;
    this.fg.controls.renameControl.setValidators([
      Validators.required,
      ...this.extraValidators,
    ]);
    this.fg.controls.renameControl.setValue(value);
    this.fg.controls.renameControl.updateValueAndValidity();
  }

  close() {
    this.dialog.visible = false;
    this.loading = false;
  }

  renameClick() {
    this.rename.emit(this.fg.controls.renameControl.value);
  }

  setLoading(isLoading: boolean) {
    this.loading = isLoading;
  }
}
